
/* // https://medium.com/javascript-inside/safely-accessing-deeply-nested-values-in-javascript-99bf72a0855a

const getNestedObject = (p, o) =>
  p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o)

function getNestedObject(p, o) {
  return p.reduce( function(xs, x) {
    return xs && xs[x] ? xs[x] : null;
  } , o);
}

*/

window.isNumber = function(n) {  // eslint-disable-line no-unused-vars
  return !isNaN(parseFloat(n)) && isFinite(n);
};

/** treats queryString search and hash equally */
function urlParamsToJSON() {  // eslint-disable-line no-unused-vars
  var
    paramString = '',
    pairs,
    result = {};
  if (window.location.search) {
    paramString = decodeURIComponent(window.location.search).replace('?', '');
  }

  if (window.location.hash) {
    paramString += paramString ? '&' : '';
    paramString += window.location.hash.replace('#', '');
  }

  pairs = paramString.slice().split('&');
  pairs.forEach(function(pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });
  return JSON.parse(JSON.stringify(result));
}

/*
  from http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
  returns a string
  use .split(',').map(Number) to get an array of numbers e.g.
     rwg.hexToRgb(color).split(',').map(Number)
*/
function hexToRgb(hex) {
  var bigint = parseInt(hex.replace('#', ''), 16);
  var r = (bigint >> 16) & 255;
  var g = (bigint >> 8) & 255;
  var b = bigint & 255;
  return r + ',' + g + ',' + b;
}

// http://stackoverflow.com/questions/5618676/how-to-parse-css-font-shorthand-format
// note that this parses any css object so prefix the string with the object type e.g. 'font: ...'
// another way which does not require an html element
// http://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
function parseCSS(cssString){
  var el = document.createElement('span');
  el.setAttribute('style', cssString);
  return el.style; // CSSStyleDeclaration object
}

function relocateElementBySelector(elementSelector, destSelector) {
  // let element = document.querySelector(elementSelector); // '[data-ol-map]'
  try {
    // document.querySelector(destSelector).appendChild(element.parentElement.removeChild(element));
    // removeChild() is unnecessary https://stackoverflow.com/questions/15408394/how-to-copy-a-dom-node-with-event-listeners/55799963#55799963
    document.querySelector(destSelector).appendChild(document.querySelector(elementSelector));
  }
  catch(err) {
    console.error(`in relocateElementBySelector(${elementSelector}, ${destSelector})`, err);
  }
}

//  // https://davidwalsh.name/convert-html-stings-dom-nodes
//  // https://stackoverflow.com/questions/494143/creating-a-new-dom-element-from-an-html-string-using-built-in-dom-methods-or-pro/35385518#35385518
//  /**
//   * @param {String} HTML representing a single element
//   * @return {Element}
//   */
//  function htmlToElement(html) {
//    var template = document.createElement('template');
//    html = html.trim(); // Never return a text node of whitespace as the result
//    template.innerHTML = html;
//    return template.content.firstChild;
//  }
//
//  // var td = htmlToElement('<td>foo</td>');
//  // var div = htmlToElement('<div><span>nested</span> <span>stuff</span></div>');
//
//  /**
//  * @param {String} HTML representing any number of sibling elements
//  * @return {NodeList}
//  */
//  function htmlToElements(html) {
//    var template = document.createElement('template');
//    template.innerHTML = html;
//    return template.content.childNodes;
//  }
//
//  // var rows = htmlToElements('<tr><td>foo</td></tr><tr><td>bar</td></tr>');

export {urlParamsToJSON, relocateElementBySelector, hexToRgb, parseCSS};
